import React, { useState } from "react";

import CreateRecordButton from "./CreateRecordButton";
import EguOutSourcingMaterialReturnDetailRegisterDialog from "../dialogTypes/EguOutSourcingMaterialReturnDetailRegisterDialog";

function EguOutSourcingMaterialReturnDetailRegisterButton(props) {
    const { id, refresh, schema, onSuccess, outSourcingMaterialReturnMstSelect, customizeErrorMsgCallback, ...others } =
        props;

    const [open, setOpen] = useState(false);


    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onRegisterSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        if (refresh) {
            refresh.refresh();
        }
    };

    return (
        <React.Fragment>
            <CreateRecordButton id={id} onClick={onOpen} {...others} />
            <EguOutSourcingMaterialReturnDetailRegisterDialog
                id={id + "-register-dialog"}
                schema={schema}
                outSourcingMaterialReturnMstSelect={outSourcingMaterialReturnMstSelect}
                open={open}
                onClose={onClose}
                onSuccess={onRegisterSuccess}
            />
        </React.Fragment>
    );
}

export default EguOutSourcingMaterialReturnDetailRegisterButton;
